import { forwardRef, useState } from 'react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

// forwardRef is required so react-hook-form's register() can attach its ref to the <input>
const Input = forwardRef(({ label, error, icon: Icon, type = 'text', className = '', ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword  = type === 'password';
  const resolvedType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-secondary mb-1">{label}</label>
      )}
      <div className="relative">
        {Icon && (
          <Icon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xl pointer-events-none" />
        )}
        <input
          ref={ref}
          type={resolvedType}
          className={`
            w-full py-3 border rounded-xl text-sm
            transition-colors focus:outline-none focus:border-primary
            ${Icon      ? 'pl-10' : 'pl-4'}
            ${isPassword ? 'pr-10' : 'pr-4'}
            ${error     ? 'border-red-400 bg-red-50' : 'border-gray-200 bg-white'}
          `}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            tabIndex={-1}
          >
            {showPassword
              ? <MdVisibilityOff className="text-xl" />
              : <MdVisibility    className="text-xl" />}
          </button>
        )}
      </div>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
});

Input.displayName = 'Input';
export default Input;
